<div class="shows-page">
    <header class="page-header">
        <div class="page-header__inner">
            <div class="page-header__left">
                <img src="/copago-logo.png" alt="Copago Logo" class="brand-logo" />
            </div>

            <div class="page-header__right">
                <div class="venue-info">
                    <div class="venue-title">{{ selectedTheater?.name || '—' }}</div>
                    <div class="venue-subtitle">
                        <mat-icon>location_on</mat-icon>
                        <span>{{ selectedTheater?.subtitle || '—' }}</span>
                    </div>
                </div>

                <button class="header-icon-button" type="button" (click)="logout()" aria-label="Logout">
                    <mat-icon>logout</mat-icon>
                </button>
            </div>
        </div>
    </header>

    <main class="page-content">
        <section class="page-section">
            <div class="section-topbar">
                <h1>Vorstellungen</h1>

                <div class="filter-actions">
                    <!-- Theater Dropdown -->
                    <div class="filter-wrapper">
                        <button type="button" class="filter-button"
                            [class.filter-button--active]="isTheaterDropdownOpen"
                            (click)="toggleTheaterDropdown($event)">
                            <mat-icon>theaters</mat-icon>
                            <span>{{ selectedTheater?.name || '—' }}</span>
                            <mat-icon class="arrow-icon">
                                {{ isTheaterDropdownOpen ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </button>

                        <div class="custom-dropdown-panel" *ngIf="isTheaterDropdownOpen"
                            (click)="$event.stopPropagation()">
                            <button type="button" class="custom-dropdown-option" *ngFor="let theater of theaters"
                                [class.custom-dropdown-option--selected]="selectedTheater?.key === theater.key"
                                (click)="selectTheater(theater)">
                                <mat-icon class="option-check">
                                    {{ selectedTheater?.key === theater.key ? 'check' : '' }} </mat-icon>
                                <span>{{ theater.name }}</span>
                            </button>
                        </div>
                    </div>

                    <!-- Date Filter -->
                    <div class="filter-wrapper">
                        <button type="button" class="filter-button" [class.filter-button--active]="isDateDropdownOpen"
                            (click)="toggleDateDropdown($event)">
                            <mat-icon>calendar_today</mat-icon>
                            <span>{{ formattedSelectedDate }}</span>

                            <mat-icon class="clear-icon" *ngIf="selectedDate" (click)="clearDateFilter($event)">
                                close
                            </mat-icon>

                            <mat-icon class="arrow-icon" *ngIf="!selectedDate">
                                {{ isDateDropdownOpen ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </button>

                        <div class="custom-date-panel" *ngIf="isDateDropdownOpen" (click)="$event.stopPropagation()">
                            <mat-calendar [selected]="selectedDate" [minDate]="minDate" [maxDate]="maxDate"
                                (selectedChange)="onDateSelected($event)">
                            </mat-calendar>
                        </div>
                    </div>
                </div>
            </div>

            <div class="shows-table-card">
                <div class="shows-table">
                    <div class="shows-table__head">
                        <div>Show</div>
                        <div>Datum</div>
                        <div>Uhrzeit</div>
                        <div>Zeitblöcke</div>
                        <div class="align-center">Res.</div>
                        <div class="align-center">Gäste</div>
                        <div></div>
                    </div>

                    <button type="button" class="shows-table__row" *ngFor="let show of filteredShows"
                        (click)="openShow(show)">
                        <div class="show-title">{{ show.title }}</div>

                        <div class="table-meta">
                            <mat-icon>calendar_today</mat-icon>
                            <span>{{ getDateLabel(show) }}</span>
                        </div>

                        <div class="table-meta">
                            <mat-icon>schedule</mat-icon>
                            <span>{{ show.timeLabel }}</span>
                        </div>

                        <div class="chips">
                            <span class="chip" *ngFor="let block of show.blocks">{{ block }}</span>
                        </div>

                        <div class="table-number align-center">{{ show.reservations }}</div>

                        <div class="table-meta align-center guests-cell">
                            <mat-icon>group</mat-icon>
                            <span>{{ show.guests }}</span>
                        </div>

                        <div class="row-arrow">
                            <mat-icon>chevron_right</mat-icon>
                        </div>
                    </button>

                    <div class="empty-state" *ngIf="!filteredShows.length">
                        Keine Vorstellungen für die ausgewählten Filter gefunden.
                    </div>
                </div>
            </div>
        </section>
    </main>
    <div class="page-loader-overlay" *ngIf="isPageLoading">
        <div class="page-loader-card">
            <mat-spinner diameter="44"></mat-spinner>
            <div class="page-loader-text">Daten werden geladen ...</div>
        </div>
    </div>
</div>